import { render, staticRenderFns } from "./ProductMainFieldsGrid.vue?vue&type=template&id=10eef652&"
import script from "./ProductMainFieldsGrid.vue?vue&type=script&lang=js&"
export * from "./ProductMainFieldsGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports